import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';

import { Box, ButtonIcon, LinkTranslatedStyledAsButton, Paper, Typography } from '@core/component';
import {
  Translate,
  YOUTUBE_URL,
  facebookUrl,
  instagramUrl,
  linkedinUrl,
  twitterUrl,
} from '@core/constant';
import { useContextMediaQuery } from '@core/context';
import { useLanguage } from '@core/hook';
import { EActionAttribute, EColor, EIcon, ESize, ETypographyVariant } from '@core/type';

import { SocialLinkProps } from '../interface-contact';

export const SocialLinksSection = () => {
  const { isPhone } = useContextMediaQuery();
  const { language } = useLanguage();

  const { t: tContact } = useTranslation(Translate.page.CONTACT);

  const { facebook, twitter, linkedin, instagram } = useMemo(() => {
    return {
      facebook: facebookUrl[language],
      instagram: instagramUrl[language],
      linkedin: linkedinUrl[language],
      twitter: twitterUrl[language],
    };
  }, [language]);

  return (
    <Box>
      <Paper padding={isPhone ? '30px 20px' : '20px'} backgroundColor={EColor.INFO}>
        <Typography
          variant={ETypographyVariant.H4}
          textAlign={'center'}
          marginBottom={isPhone ? '32px' : '24px'}
        >
          {tContact('weOnSocialMedia')}
        </Typography>
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'} gap={'32px'}>
          <SocialLink type={EIcon.FACEBOOK} href={facebook} />
          <SocialLink type={EIcon.TWITTER} href={twitter} />
          <SocialLink type={EIcon.LINKED_IN} href={linkedin} />
          <SocialLink type={EIcon.YOUTUBE} href={YOUTUBE_URL} />
          <SocialLink type={EIcon.INSTAGRAM} href={instagram} />
        </Box>
      </Paper>
    </Box>
  );
};

const SocialLink = ({ type, href }: SocialLinkProps) => {
  const { t } = useTranslation(Translate.common.ARIA);

  return (
    <LinkTranslatedStyledAsButton href={href} target={'_blank'} borderRadius={'50%'} padding="0">
      <ButtonIcon
        iconProps={{
          type,
          size: ESize.LG,
          color: { commonType: EColor.WHITE, intensity: EColor.R900 },
        }}
        size={ESize.LG}
        as={EActionAttribute.SPAN}
        backgroundColor={EColor.PRIMARY}
        hoverStyles={{
          backgroundColor: { semanticType: EColor.PRIMARY, variant: EColor.DARK },
        }}
        aria-label={t('weOnSocialMedia')}
      />
    </LinkTranslatedStyledAsButton>
  );
};
